<template>
  <div>
    <div class="flex-x-center">
      <div class="profile-content">
        <h1 class="flex-x-center test-name">考后调剂</h1>
        
        <!-- Status Box -->
        <div class="flex-x-y-center" style="margin-top: 20px;">
          <div class="two-boxx" style="height: auto; padding: 30px;">
            <div class="dispensing">
              <div class="iconfont icon-jinggao warn-icon flex-x-center" :style="{ color: process.content.adjust_switch == 2 ? '#67C23A' : '#F56C6C' }"></div>
              <div class="flex-x-center change-text" style="font-size: 18px; margin-top: 20px;"
                :style="{ color: process.content.adjust_switch == 2 ? '#67C23A' : '#F56C6C' }">
                <span v-if="process.content.adjust_switch === 0">无需调剂或不可调剂</span>
                <span v-else-if="process.content.adjust_switch === 1">符合调剂条件</span>
                <span v-else-if="process.content.adjust_switch === 2">调剂审核通过</span>
                <span v-else-if="process.content.adjust_switch === 3">调剂待审核</span>
                <span v-else-if="process.content.adjust_switch === -1">调剂未通过或无资格</span>
              </div>
              <div class="flex-x-center not-open" style="margin-top: 15px; text-align: center; line-height: 1.5; padding: 0 20px;">
                {{ process.content.adjust_message || '考生成绩信息核算中' }}
                <br>
                <div v-if="process.content.adjust_switch === 1 || process.content.adjust_switch === -1 || process.content.adjust_switch === 3 || process.content.adjust_switch === 2" style="color: #409EFF; margin-top: 10px;">
                  您目前已发起了 {{ process.content.adjust_count }} 次申请（系统允许最多 {{ process.content.adjust_limit }} 次）。
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Position Selection when adjust_switch == 1 -->
        <div class="flex-x-center" v-if="process.content.adjust_switch === 1 && process.content.position_list && process.content.position_list.length > 0">
          <div class="profile-content-position" style="width: 100%;">
            <div style="color: gray; font-size: 15px; font-weight: bold; margin-bottom: 15px;">请选择可调剂的新职位：</div>
            <div class="positon-list">
              <el-table :data="process.content.position_list" style="width: 100%;" border highlight-current-row>
                <el-table-column label="选择" width="80" align="center">
                  <template slot-scope="scoped">
                    <el-radio v-model="positionChoice" :label="scoped.row.id"><span></span></el-radio>
                  </template>
                </el-table-column>
                <el-table-column prop="title" label="职位名称"></el-table-column>
                <el-table-column prop="code" label="职位代码" width="160"></el-table-column>
                <el-table-column prop="company" label="单位名称"></el-table-column>
                <el-table-column prop="adjust_num" label="缺口人数" width="100" align="center">
                  <template slot-scope="scope">
                    <span style="color: red; font-weight: bold;">{{ scope.row.adjust_num }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            
            <div style="margin-top: 25px;" v-if="positionChoice">
               <el-input type="textarea" rows="3" v-model="adjustMessage" placeholder="您可以填写调剂申请补充说明（非必选）..."></el-input>
            </div>

            <div class="flex-x-center" style="margin-top: 30px;">
              <el-button type="primary" size="medium" @click="submitAdjustment" :loading="isSubmitting" style="width: 200px; height: 45px; font-size: 16px;">提交调剂申请</el-button>
            </div>
          </div>
        </div>

        <!-- Next Button if finished or passing through -->
        <div class="flex-x-center agree-sign-next" style="margin-top: 40px;">
          <button class="next-step" @click="$parent.next()" style="width: 200px;">进入下一步</button>
        </div>
      </div>
    </div>
    <div class="flex-x-center agree-sign-next">
      <router-link to="/" class="next-step flex-x-y-center" style="width: 200px;">返回首页</router-link>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { useMainStore } from "@/store/piniaStore";
import { erroralert, successalert } from "@/utils/alert";
import { reqProjectSavedata } from "@/api";

export default {
  data() {
    return {
      positionChoice: "",
      adjustMessage: "",
      isSubmitting: false,
    };
  },
  props: {
    // 流程
    process: {
      type: Object,
      default() {
        return { content: {} };
      },
    },
  },
  methods: {
    submitAdjustment() {
      if (!this.positionChoice) {
        return erroralert("请在表格中选择一个拟调剂的新职位");
      }
      this.isSubmitting = true;
      let project_id = this.$parent.projectDetail.project_info.id;
      reqProjectSavedata({
        step_name: "khtj",
        project_id: project_id,
        current_step: this.process.current_step,
        position_id: this.positionChoice,
        adjust_message: this.adjustMessage
      }).then((res) => {
        this.isSubmitting = false;
        if (res.data.code === 1) {
          successalert("调剂申请已经成功提交！");
          // Refresh state via parent API to ensure exact state mapping
          if (this.$parent && this.$parent.reqProject) {
              this.$parent.reqProject();
          } else {
              this.process.content.adjust_switch = 3;
              this.process.content.adjust_count = (this.process.content.adjust_count || 0) + 1;
              this.process.content.adjust_message = "您的调剂申请已通过网站上报，请等待后续人员审核。";
              this.positionChoice = "";
          }
        } else {
          erroralert(res.data.msg);
        }
      }).catch((e) => {
        this.isSubmitting = false;
        erroralert("提交失败,请重试！");
      });
    }
  },
  computed: {
    ...mapState(useMainStore, {
      projectDetail: "getProjectDetail",
    }),
  },
  mounted() {
    // Scroll to top upon entry
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped>
.positon-list {
  border: 1px solid rgb(231, 225, 225);
  border-radius: 4px;
}

.not-open {
  color: rgb(120, 120, 120);
}

.change-text {
  font-weight: 500;
}

.test-name {
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0.5px;
  color: #333;
}

.warn-icon {
  font-size: 60px;
}

.two-boxx {
  width: 80%;
  border: rgb(231, 225, 225) 1px solid;
  border-radius: 6px;
  background-color: #fafbfc;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .05);
}

.profile-content {
  margin-top: 20px;
  width: 83%;
  padding: 40px 50px 80px;
  background: white !important;
  border-radius: 8px;
  box-sizing: border-box;
  box-shadow: 0 4px 6px rgba(0, 0, 0, .05);
}

.profile-content-position {
  margin-top: 30px;
  padding: 30px 40px;
  background: #fdfdfd !important;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  box-sizing: border-box;
}

.agree-sign-next {
  margin-top: 35px;
}
.next-step {
  height: 40px;
  line-height: 40px;
  background: #409EFF;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  font-size: 15px;
  display: block;
  text-decoration: none;
}
.next-step:hover {
  background: #66b1ff;
  color: #fff;
}
</style>
